export const balanceToken = -1

export const multiplyToken = 0

export const starsToken = 9
